function timerManage(){
    this.timers={};
    this.functionOnTime={};
    this.time_update=getCurrentTime();
}
timerManage.prototype={
    addTimer:function(selector,time_end,delete_on_module_load,funOnEnd){
        this.timers[selector]={time_end:time_end,delete_on_module_load:delete_on_module_load,funOnEnd:funOnEnd};
    },
    deleteTimer:function(selector){
        if(typeof this.timers[selector]!="undefined"){
            delete this.timers[selector];
        }
        
    },
    onModuleLoad:function(){
        var to_del=[],i;
        for(i in this.timers){
            if(this.timers[i].delete_on_module_load){
                to_del.push(i);
            }
        }
        for(i in to_del){
            delete this.timers[to_del[i]];
        }
    },
    addFunctionOnTime:function(func,time){
        if(typeof this.functionOnTime[time]=="undefined"){
            this.functionOnTime[time]=[func];
        }
        else{
            this.functionOnTime[time].push(func);
        }
    },
    updateOnTime:function(time){
        var i;
        if(typeof this.functionOnTime[time]!="undefined"){
            for(i in this.functionOnTime[time]){
                this.functionOnTime[time][i]();
            }
        }
        delete this.functionOnTime[time];
    },
    alltimers:function(a){ 
        if(a==1){
            var th_tmp=this;
            setTimeout(function(){
                th_tmp.alltimers(1);
            },999);  
        }
        var selector,to_del=[],obj,bum,i;
        var time_current=$.getCurrentTime();
        for(this.time_update;this.time_update<time_current;this.time_update++){
            this.updateOnTime(this.time_update);
        }
        
        for(selector in this.timers){
            obj=$(selector);
            bum=this.timers[selector];
            if(obj.length){
                obj.html(timeFormat(bum.time_end-time_current));
            }
            if(time_current<=bum.time_end){
                if(obj.length){
                    
                }
            }
            else{
                to_del.push(selector);
                if(obj.length){
                    obj.html(timeFormat(0));
                    obj.trigger("timer_end");
                }
                if(typeof bum.funOnEnd!="undefined"){
                    bum.funOnEnd();
                }
            }
        }
        for(i in to_del){
            delete this.timers[to_del[i]];
        }    
        var cash=_cashObjSet.takeCash();
        _timerCash.checkStorage(cash);
        _eventHandler.trigger("cash",cash);
        $("#cashJSInsertTimer").html("$"+numberFormat(cash,2));
    }
};
var _timerManager=new timerManage();
